<!-- Componente para exibir os itens de navegação utilizando uma navbar -->
<template lang="html">
  <div>
  <v-navigation-drawer temporary absolute v-model="drawer" :class="{ 'hidden-md-and-up': isMdAndUp}">
    <v-list>
      <v-list-item v-for="(item, i) in items" :key="i"
      v-if="item.publico || ( logged && (item.id !== 3 || permissaoCriarProjetoExtensao === true) )" :to="{name: item.link}">
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{item.text}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="logged" @click="PERFORM_LOGOUT">
        <v-list-item-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Sair</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
  <!-- The navbar wrapper (a common toolbar) -->
  <v-toolbar text fixed dark>
    <v-avatar :tile="true" size='50px'> <img :src="require('@/assets/logo_ufes.png')" alt="logo"> </v-avatar>
    <v-app-bar-nav-icon app @click.stop="drawer = !drawer" :class="{ 'hidden-md-and-up': isMdAndUp}"></v-app-bar-nav-icon>
    <v-toolbar-title>Portal dos Projetos</v-toolbar-title>

    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down text-xs-right" >
      <template v-for="(item, i) in items">
        <v-btn text v-if="item.publico || ( logged && item.id === 1 ) || ( permissaoCriarProjetoExtensao && item.id === 3) || ( administrador && item.id === 4)" :to="{name: item.link}" :key="i"> {{item.text}} </v-btn>
      </template>
    </v-toolbar-items>
    <v-spacer></v-spacer>

    <span v-if="logged">
      <v-icon dark>account_circle</v-icon>
      {{username}} (<a class="nav_link" @click="PERFORM_LOGOUT()"><strong>sair</strong></a>)
    </span>
    <span v-else>
      Por favor, realize o <router-link class="nav_link" :to="{name: 'Login'}">Login</router-link>
    </span>
  </v-toolbar>
</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    // Menu items from left to right
    data: () => ({
      drawer: false,
      items: [
        { icon: 'content_paste', text: 'Meus Projetos', link: 'MeusProjetos', publico: false, id: 1 },
        { icon: 'search', text: 'Consulta', link: 'ConsultaProjetos', publico: true, id: 2 },
        { icon: 'create', text: 'Novo Projeto', link: 'NovoProjeto', publico: false, id: 3 },
        { icon: 'create', text: 'Administração', link: 'Administracao', publico: false, id: 4 },
        // { icon: 'account_balance_wallet', text: 'Bolsas', link: 'ListaBolsas', publico: true, id: 4 },
        { icon: 'help', text: 'Ajuda', link: 'Ajuda', publico: true, id: 5 }
        // { icon: 'help', text: 'Pesquisa', link: 'Pesquisa', publico: true, id: 6 }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'vinculo', 'permissaoCriarProjetoExtensao', 'administrador']),
      isMdAndUp () {
        let mdAndUp = this.$vuetify.breakpoint.mdAndUp
        if (mdAndUp) {
          this.drawer = false
        }
        return mdAndUp
      }
    },
    methods: {
      ...mapActions('auth', ['PERFORM_LOGOUT'])
    }
  }
</script>

<!-- Why scoped css break the background highlighting of active items? -->
<style lang="css" scoped>
  a.nav_link {
    color: #ffffff;
    text-decoration: none;
    font-weight: bold;
  }
  a.nav_link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .toolbar__items .btn {
    width: 125px;
    text-transform: capitalize;
    border-bottom: 0.2em solid grey;
  }
  .toolbar__items .btn--active {
    border-bottom: 0.5em solid #1976d2;
  }
  .toolbar__title {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// menu.vue?9337920a